// Which rentals hold units on a calendar day, and for how long each runs.
// A rental counts from rentalStart to effectiveEnd inclusive — the same span the
// backend's inventory_free_on subtracts, so a day's list matches its free count.

import dayjs from '@app/utils/dayjs-setup';

import type { ActiveRental } from '../../types';

const day = (value?: string | null): string | null => (value ? dayjs(value).format('YYYY-MM-DD') : null);

export const rentalsOnDate = (rentals: readonly ActiveRental[], date: string): ActiveRental[] =>
  rentals.filter((rental) => {
    const start = day(rental.rentalStart);
    const end = day(rental.effectiveEnd);
    return start != null && end != null && start <= date && date <= end;
  });

export const rentedOnDate = (rentals: readonly ActiveRental[], date: string): number =>
  rentalsOnDate(rentals, date).reduce((sum, rental) => sum + Number(rental.quantity), 0);

/** Days the rental runs, both ends included; null without a start or end. */
export const rentalLengthDays = (rental: ActiveRental): number | null => {
  const start = day(rental.rentalStart);
  const end = day(rental.effectiveEnd);
  if (start == null || end == null) return null;
  return dayjs(end).diff(dayjs(start), 'day') + 1;
};

export type RentalState = 'returned' | 'overdue' | 'out';

export const rentalState = (rental: ActiveRental, today: string): RentalState => {
  if (rental.isReturned) return 'returned';
  const end = day(rental.effectiveEnd);
  return end != null && end < today ? 'overdue' : 'out';
};
